export const LANDING_PAGE_VIEW_PATH = "/";
export const BETS_VIEW_PATH = "/fhe839g";
export const LIQUIDITY_VIEW_PATH = "/fhe83az";
export const DASHBOARD_VIEW_PATH = "/fhe81ml";
export const FAUCET_VIEW_PATH = "/fhe834qw"